import React from "react"
import { Box } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"
import { dateFormatReceiver } from "@utils"


export default function dorColumn() {

	const dateFormatter = date => {
		if (date.length < 2) return formatDate(date, { isString: true, receivedFormat: dateFormatReceiver(date) })
		return date.reduce((acc, d, index) => {
			const formattedDate = formatDate(d, { isString: true, receivedFormat: dateFormatReceiver(d) })
			return index > 0 ? acc.concat(', ', formattedDate) : acc.concat(formattedDate)
		}, '')
	}

	return {
		name: "pickup_date_translation", label: "Date of Rental",
		options: {
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
				{dateFormatter(value)}
			</Box>
		}
	}
}